module.exports = __webpack_public_path__ + "img/d2.2bbde4a7.jpg";